"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
// Relements
var modal_1 = __importDefault(require("relements/build/esm/overlays/modal"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
// Icons
var SocialPromptIcon_svg_1 = __importDefault(require("./icons/SocialPromptIcon.svg"));
var TextPromptIcon_svg_1 = __importDefault(require("./icons/TextPromptIcon.svg"));
// Utils
var utils_1 = require("@src/utils");
var Title = styled_components_1["default"](text_1["default"])(function (props) { return ({
    color: props.theme.colors.black.haptik,
}); });
var SubTitle = styled_components_1["default"](text_1["default"])(function (props) { return ({
    marginTop: '16px',
    color: props.theme.colors.black.haptik,
}); });
var ItemWrapper = styled_components_1["default"](box_1["default"])(function (props) { return ({
    padding: 0,
    background: props.theme.colors.grey.pastel,
    border: "1px solid " + props.theme.colors.grey.haptik,
    borderRadius: props.theme.radii.sm,
    width: 356,
    flexDirection: 'column',
    alignItems: 'center',
}); });
var StyledIcon = styled_components_1["default"](icon_1["default"])({
    width: 356,
    height: 274,
    pointerEvents: 'none',
});
var SubTitleItem = styled_components_1["default"](text_1["default"])(function (props) { return ({
    marginTop: props.theme.space.md,
    color: props.theme.colors.black.haptik,
    textAlign: 'center',
    fontSize: 15,
}); });
var ButtonWrapper = styled_components_1["default"](button_1["default"])(function (props) { return ({
    width: 310,
    height: 42,
    marginTop: 24,
    fontSize: props.theme.fontSizes[3],
}); });
var CreateNewTrigger = function (_a) {
    var isActive = _a.isActive, setIsActive = _a.setIsActive, onTextPromptClick = _a.onTextPromptClick, onSocialPromptClick = _a.onSocialPromptClick;
    var isProductionEnv = utils_1.isProduction();
    // When user selects Text & CTA Bot Prompt
    var onTextPromptSelect = function () {
        setIsActive(false);
        onTextPromptClick();
    };
    // When user select Social Bot Prompt
    var onSocialPromptSelect = function () {
        setIsActive(false);
        onSocialPromptClick();
    };
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(button_1["default"], { themed: true, variant: isProductionEnv ? 'disabled' : 'secondary', disabled: isProductionEnv, onClick: function () { return setIsActive(true); } }, "Create a New Trigger"),
        react_1["default"].createElement(modal_1["default"], { themed: true, active: isActive, onClose: function () { return setIsActive(false); } },
            react_1["default"].createElement(box_1["default"], { padding: "0", width: "728px", flexDirection: "column", alignItems: "center", margin: "16px 39px 16px 69px" },
                react_1["default"].createElement(Title, { variant: "display-2.semi-bold" }, "Draw attention and drive usage!"),
                react_1["default"].createElement(SubTitle, { variant: "body.lg", marginTop: "16px" }, "Select a type of bot prompt you\u2019d like to set up"),
                react_1["default"].createElement(box_1["default"], { padding: "0", width: "734px", justifyContent: "space-between", marginTop: "24px" },
                    react_1["default"].createElement(ItemWrapper, null,
                        react_1["default"].createElement(StyledIcon, { src: SocialPromptIcon_svg_1["default"] }),
                        react_1["default"].createElement(box_1["default"], { padding: "0", margin: "24px", flexDirection: "column", alignItems: "center" },
                            react_1["default"].createElement(Title, { variant: "h2.semi-bold" }, "Omnichannel Bot Prompts"),
                            react_1["default"].createElement(SubTitleItem, { variant: "body.lg" }, "Attract users to all the social channels your bot is available on and increase discoverability."),
                            react_1["default"].createElement(ButtonWrapper, { themed: true, variant: "success", onClick: onSocialPromptSelect }, "Select"))),
                    react_1["default"].createElement(ItemWrapper, null,
                        react_1["default"].createElement(StyledIcon, { src: TextPromptIcon_svg_1["default"] }),
                        react_1["default"].createElement(box_1["default"], { padding: "0", margin: "24px", flexDirection: "column", alignItems: "center" },
                            react_1["default"].createElement(Title, { variant: "h2.semi-bold" }, "Text & CTA Bot Prompts"),
                            react_1["default"].createElement(SubTitleItem, { variant: "body.lg" }, "Showcase your bot\u2019s capabilities and engage existing website users with custom triggers"),
                            react_1["default"].createElement(ButtonWrapper, { themed: true, onClick: onTextPromptSelect }, "Select"))))))));
};
exports["default"] = CreateNewTrigger;
